import { render, staticRenderFns } from "./ClassificacaoWindowLB.vue?vue&type=template&id=47ba2064&scoped=true&"
import script from "./ClassificacaoWindowLB.vue?vue&type=script&lang=js&"
export * from "./ClassificacaoWindowLB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ba2064",
  null
  
)

export default component.exports